import { defineMessages } from "react-intl";

const messages = defineMessages({
  aiFeedbackReportSentDescription: {
    id: "email.creation.aiInlineWriter.report.sentDescription",
    defaultMessage: "Thank you for your feedback.",
    description: "Report sent notification description",
  },
  aiFeedbackReportSentTitle: {
    id: "email.creation.aiInlineWriter.report.sentTitle",
    defaultMessage: "Report sent",
    description: "Report sent notification title",
  },
  entitiesSubscribeError: {
    id: "email.entitiesSubscribe.error",
    defaultMessage: "Error subscribing record(s). Please try again or contact support.",
    description: "Text of notification when entities subscribed failed",
  },
  entitiesSubscribeSuccess: {
    id: "email.entitiesSubscribe.success",
    defaultMessage: "Record(s) subscribed successfully.",
    description: "Text of notification when entities subscribe successfully",
  },
  entitiesUnsubscribeError: {
    id: "email.entitiesUnsubscribe.error",
    defaultMessage: "Error unsubscribing record(s). Please try again or contact support.",
    description: "Text of notification when entities unsubscribe failed",
  },
  entitiesUnsubscribeSuccess: {
    id: "email.entitiesUnsubscribe.success",
    defaultMessage: "Record(s) unsubscribed successfully.",
    description: "Text of notification when entities unsubscribed successfully",
  },
  sendScheduledDescription: {
    id: "email.send.scheduled.description",
    defaultMessage: "Will be sent on {date}",
    description: "Description of notification when email is scheduled",
  },
  sendScheduledSuccess: {
    id: "email.send.scheduled.success",
    defaultMessage: "Email scheduled",
    description: "Title of notification when email is scheduled",
  },
  sendUnknownError: {
    id: "email.send.unknownError",
    defaultMessage: "Email not sent. Please try again or contact support.",
    description: "Email send unknown error",
  },
  syncModalCancel: {
    id: "email.syncModal.cancel",
    defaultMessage: "Maybe Later",
    description: "Sync modal cancel",
  },
  syncModalFailedConnectionOk: {
    id: "email.syncModal.failedConnectionOk",
    defaultMessage: "Reconnect my email",
    description: "Sync modal with failed connection Ok",
  },
  syncModalFailedConnectionText: {
    id: "email.syncModal.failedConnectionText",
    defaultMessage:
      "Let’s get you synced again. Reconnecting only takes a few seconds - you’ll be back on track in no time! And don’t worry, all your settings and preferences will be saved.",
    description: "Sync modal with failed connection title",
  },
  syncModalFailedConnectionTitle: {
    id: "email.syncModal.failedConnectionTitle",
    defaultMessage: "Uh oh! Your email isn’t connected",
    description: "Sync modal with failed connection title",
  },
  syncModalNoConnectionOk: {
    id: "email.syncModal.noConnectionOk",
    defaultMessage: "Sync my email",
    description: "Sync modal with no connection Ok",
  },
  syncModalNoConnectionText: {
    id: "email.syncModal.noConnectionText",
    defaultMessage:
      "When you sync your email, MMC will: {br} 1. Auto-log the activity for you{br} 2. Save the content of the email to the activity{br} 3. Track opens and clicks{br}{br} {icon} <b>Pro Tip:</b> Use Lasso to send emails in bulk",
    description: "Sync modal with no connection title",
  },
  syncModalNoConnectionTitle: {
    id: "email.syncModal.noConnectionTitle",
    defaultMessage: "Set up email in Map My Customers ",
    description: "Sync modal with no connection title",
  },
  uploadFileSizeExceededError: {
    id: "email.uploadFile.fileSizeExceededError",
    defaultMessage: "File size exceeded",
    description: "File size exceeded",
  },
  uploadFileSizeExceededErrorDescription: {
    id: "email.uploadFile.fileSizeExceededErrorDescription",
    defaultMessage: "The file size exceeds the limit of 25 MB",
    description: "File size exceeded description",
  },
});

export default messages;
